import React, { Component } from 'react';
import { graphql, compose } from 'react-apollo';
import PropTypes from 'prop-types';
import { getStoreByAdmin } from './queries';
import { updateStoreByAdmin } from './mutation';
import { Slide } from 'react-slideshow-image';
import moment from 'moment';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import Typography from '@material-ui/core/Typography';
import CategoryIcon from '@material-ui/icons/Category';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ContactPhoneIcon from '@material-ui/icons/ContactPhone';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import ContactMailIcon from '@material-ui/icons/ContactMail';
import ListItemText from '@material-ui/core/ListItemText';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import EditIcon from '@material-ui/icons/Edit';
import SaveIcon from '@material-ui/icons/Save';
import CancelIcon from '@material-ui/icons/Cancel';
import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/Add';
import CardMedia from '@material-ui/core/CardMedia';
import IconButton from '@material-ui/core/IconButton';
// core components
import GridItem from '../../../components/Grid/GridItem';
import Card from '../../../components/Card/Card';
import CardBody from '../../../components/Card/CardBody';
import GridContainer from '../../../components/Grid/GridContainer';
import styles from './style';
import config from '../../../config/config';

class DetailStore extends Component {
  constructor(props) {
    super(props);
    const { detailStore } = this.props;
    this.state = {
      detailStore,
      isEditing: false,
      isSaving: false,
      editForm: {
        name: '',
        phone: '',
        location: '',
        email: '',
        openHour: '',
        closeHour: ''
      },
      filesToUpload: [],
      uploadedImageUrls: [],
      hasPictureUpdate: false,
      existingImages: [],
      removedImageIndexes: []
    };
  }

  componentDidUpdate(prevProps) {
    const { detailStore } = this.props;
    if (prevProps.detailStore !== detailStore && detailStore) {
      this.setState({ 
        detailStore: detailStore,
        editForm: {
          name: detailStore.name || '',
          phone: detailStore.phone || '',
          location: detailStore.location || '',
          email: detailStore.email || '',
          openHour: detailStore.openHour || '',
          closeHour: detailStore.closeHour || ''
        },
        filesToUpload: [],
        uploadedImageUrls: [],
        hasPictureUpdate: false,
        existingImages: detailStore.imagesStore || [],
        removedImageIndexes: []
      });
    }
  }

  handleEditClick = () => {
    const { detailStore } = this.state;
    this.setState({
      isEditing: true,
      editForm: {
        name: detailStore.name || '',
        phone: detailStore.phone || '',
        location: detailStore.location || '',
        email: detailStore.email || '',
        openHour: detailStore.openHour || '',
        closeHour: detailStore.closeHour || ''
      }
    });
  };

  handleCancelEdit = () => {
    this.setState({ isEditing: false });
  };

  handleInputChange = (field) => (event) => {
    this.setState({
      editForm: {
        ...this.state.editForm,
        [field]: event.target.value
      }
    });
  };

  handleImageUpload = (event) => {
    const files = Array.from(event.target.files);
    this.setState({
      filesToUpload: [...this.state.filesToUpload, ...files],
      hasPictureUpdate: true
    });
  };

  handleRemoveImage = (index) => {
    const newFiles = this.state.filesToUpload.filter((_, i) => i !== index);
    this.setState({
      filesToUpload: newFiles,
      hasPictureUpdate: newFiles.length > 0 || this.state.removedImageIndexes.length > 0
    });
  };

  handleRemoveExistingImage = (index) => {
    const { removedImageIndexes } = this.state;
    if (!removedImageIndexes.includes(index)) {
      this.setState({
        removedImageIndexes: [...removedImageIndexes, index],
        hasPictureUpdate: true
      });
    }
  };

  handleRestoreExistingImage = (index) => {
    const { removedImageIndexes } = this.state;
    this.setState({
      removedImageIndexes: removedImageIndexes.filter(i => i !== index),
      hasPictureUpdate: removedImageIndexes.length > 1 || this.state.filesToUpload.length > 0
    });
  };

  handleSave = async () => {
    const { updateStoreByAdmin } = this.props;
    const { editForm, detailStore, filesToUpload, hasPictureUpdate, existingImages, removedImageIndexes } = this.state;
    
    this.setState({ isSaving: true });
    
    let uploadedImageUrls = [];
    
    // Upload images first if there are any
    if (hasPictureUpdate && filesToUpload.length > 0) {
      try {
        const formData = new FormData();
        filesToUpload.forEach((file, i) => {
          formData.append(i, file);
        });

        const uploadResponse = await fetch(`${config.upload}`, {
          method: 'POST',
          body: formData,
        });
        
        const uploadResult = await uploadResponse.json();

        // Handle multiple images - the API might return an array or single object
        if (Array.isArray(uploadResult)) {
          uploadedImageUrls = uploadResult.map(img => img.file.uri);
        } else if (uploadResult.files && Array.isArray(uploadResult.files)) {
          // Multiple files response: { success: true, files: [{ file: {...} }, ...] }
          uploadedImageUrls = uploadResult.files.map(img => img.file.uri);
        } else if (uploadResult.file && uploadResult.file.uri) {
          // Single file response: { success: true, file: {...} }
          uploadedImageUrls = [uploadResult.file.uri];
        } else if (uploadResult.uri) {
          uploadedImageUrls = [uploadResult.uri];
        }
        
        console.log('Images uploaded successfully:', uploadedImageUrls);
      } catch (error) {
        console.error('Error uploading images:', error);
        alert('Error al subir las imágenes: ' + error.message);
        this.setState({ isSaving: false });
        return;
      }
    }
    
    // Combine existing images (minus removed ones) with new uploaded images
    const remainingExistingImages = existingImages
      .map((img, index) => ({ ...img, originalIndex: index }))
      .filter((img, index) => !removedImageIndexes.includes(img.originalIndex))
      .map(img => img.full || img.uri || img.url); // Get the URL from different possible structures
    
    const allImageUrls = [...remainingExistingImages, ...uploadedImageUrls];
    
    // Clean and validate the data before sending
    const cleanedData = {
      id: detailStore.id,
      name: editForm.name.trim(),
      phone: editForm.phone.trim(),
      location: editForm.location.trim(),
      email: editForm.email.trim(),
      openHour: editForm.openHour.trim() || null,
      closeHour: editForm.closeHour.trim() || null,
      hasPictureUpdate: hasPictureUpdate,
      imagesNew: hasPictureUpdate ? allImageUrls : []
    };
    
    console.log('Saving store with cleaned data:', cleanedData);
    
    updateStoreByAdmin({
      variables: {
        input: cleanedData
      }
    })
    .then((result) => {
      console.log('Store updated successfully:', result);
      this.setState({ 
        isEditing: false, 
        isSaving: false,
        filesToUpload: [],
        uploadedImageUrls: [],
        hasPictureUpdate: false,
        existingImages: [],
        removedImageIndexes: []
      });
      // Refetch the data instead of reloading the page
      if (this.props.data && this.props.data.refetch) {
        this.props.data.refetch();
      }
    })
    .catch((error) => {
      console.error('Error updating store:', error);
      this.setState({ isSaving: false });
      // Show error message to user
      alert('Error al guardar la tienda: ' + (error.message || 'Error desconocido'));
    });
  };

  renderCategories = categories => {
    if (categories && categories.length > 0) {
      return categories.map((category, index) => (
        <Typography key={index} style={{ color: 'black' }}>
          {category}
        </Typography>
      ));
    } else {
      return (
        <Typography style={{ color: 'black' }}>No Category Existing</Typography>
      );
    }
  };
  render() {
    const { classes, loading } = this.props;
    if (loading || !this.state.detailStore) return null;
    const { detailStore, isEditing, editForm } = this.state;
    const {
      name,
      phone,
      location,
      openHour,
      closeHour,
      imagesStore,
      email,
      categories
    } = detailStore;
    const openHourDisplay = openHour && openHour !== 'Invalid date' ? 
      moment(openHour, 'h:mm A').isValid() ? 
        moment(openHour, 'h:mm A').format('HH:mm') : 
        openHour : 
      'N/A';
    const closeHourDisplay = closeHour && closeHour !== 'Invalid date' ? 
      moment(closeHour, 'h:mm A').isValid() ? 
        moment(closeHour, 'h:mm A').format('HH:mm') : 
        closeHour : 
      'N/A';
    const properties = {
      duration: 5000,
      transitionDuration: 500,
      infinite: true,
      indicators: true,
      arrows: true
    };
    return (
      <React.Fragment>
        <GridContainer justify="center">
          <GridItem xs={20} sm={12} md={10}>
            <Card>
              <CardBody>
                <GridContainer justify="center">
                  <GridItem xs={12} sm={12} md={5}>
                    {imagesStore ? (
                      <GridItem xs={12} sm={12} md={12}>
                        {imagesStore.length > 0 ? (
                          isEditing ? (
                            <div>
                              <Typography variant="h6" style={{ marginBottom: '16px' }}>
                                Imágenes Existentes
                              </Typography>
                              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                                {imagesStore.map((item, index) => {
                                  const isRemoved = this.state.removedImageIndexes.includes(index);
                                  return (
                                    <div 
                                      key={index} 
                                      style={{ 
                                        position: 'relative', 
                                        width: '100px', 
                                        height: '100px',
                                        opacity: isRemoved ? 0.5 : 1,
                                        border: isRemoved ? '2px solid red' : '2px solid transparent'
                                      }}
                                    >
                                      <img
                                        src={item.full}
                                        alt={`Existing ${index}`}
                                        style={{
                                          width: '100%',
                                          height: '100%',
                                          objectFit: 'cover',
                                          borderRadius: '4px'
                                        }}
                                      />
                                      <IconButton
                                        size="small"
                                        style={{
                                          position: 'absolute',
                                          top: '4px',
                                          right: '4px',
                                          backgroundColor: 'rgba(255, 255, 255, 0.8)'
                                        }}
                                        onClick={() => isRemoved ? 
                                          this.handleRestoreExistingImage(index) : 
                                          this.handleRemoveExistingImage(index)
                                        }
                                      >
                                        {isRemoved ? (
                                          <AddIcon fontSize="small" />
                                        ) : (
                                          <DeleteIcon fontSize="small" />
                                        )}
                                      </IconButton>
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          ) : (
                            <Slide {...properties}>
                              {imagesStore.map((item, index) => (
                                <div className={classes.itemSlide} key={index}>
                                  <img
                                    className={classes.img}
                                    src={item.full}
                                    alt={`${index}`}
                                  />
                                </div>
                              ))}
                            </Slide>
                          )
                        ) : (
                          <Typography className={classes.textVisited}>
                            Not exit Image Of Store
                          </Typography>
                        )}
                      </GridItem>
                    ) : null}
                    
                    {/* Image Management Section */}
                    {isEditing && (
                      <GridItem xs={12} sm={12} md={12} style={{ marginTop: '20px' }}>
                        <Typography variant="h6" style={{ marginBottom: '16px' }}>
                          Gestión de Imágenes
                        </Typography>
                        
                        {/* File Upload */}
                        <input
                          accept="image/*"
                          id="image-upload"
                          type="file"
                          multiple
                          style={{ display: 'none' }}
                          onChange={this.handleImageUpload}
                        />
                        <label htmlFor="image-upload">
                          <Button
                            variant="outlined"
                            component="span"
                            startIcon={<AddIcon />}
                            style={{ marginBottom: '16px' }}
                          >
                            Agregar Imágenes
                          </Button>
                        </label>
                        
                        {/* Preview New Images */}
                        {this.state.filesToUpload.length > 0 && (
                          <div>
                            <Typography variant="subtitle2" style={{ marginBottom: '8px' }}>
                              Nuevas Imágenes ({this.state.filesToUpload.length}):
                            </Typography>
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                              {this.state.filesToUpload.map((file, index) => (
                                <div key={index} style={{ position: 'relative', width: '100px', height: '100px' }}>
                                  <img
                                    src={URL.createObjectURL(file)}
                                    alt={`New ${index}`}
                                    style={{
                                      width: '100%',
                                      height: '100%',
                                      objectFit: 'cover',
                                      borderRadius: '4px'
                                    }}
                                  />
                                  <IconButton
                                    size="small"
                                    style={{
                                      position: 'absolute',
                                      top: '4px',
                                      right: '4px',
                                      backgroundColor: 'rgba(255, 255, 255, 0.8)'
                                    }}
                                    onClick={() => this.handleRemoveImage(index)}
                                  >
                                    <DeleteIcon fontSize="small" />
                                  </IconButton>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                      </GridItem>
                    )}
                  </GridItem>
                  <GridItem xs={12} sm={12} md={7}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                      <Typography variant="h5" component="h2">
                        Store Details
                      </Typography>
                      {!isEditing ? (
                        <Button
                          variant="contained"
                          color="primary"
                          startIcon={<EditIcon />}
                          onClick={this.handleEditClick}
                        >
                          Editar
                        </Button>
                      ) : (
                        <div style={{ display: 'flex', gap: '8px' }}>
                          <Button
                            variant="contained"
                            color="primary"
                            startIcon={<SaveIcon />}
                            onClick={this.handleSave}
                            disabled={this.state.isSaving}
                          >
                            {this.state.isSaving ? 'Guardando...' : 'Guardar'}
                          </Button>
                          <Button
                            variant="outlined"
                            startIcon={<CancelIcon />}
                            onClick={this.handleCancelEdit}
                            disabled={this.state.isSaving}
                          >
                            Cancelar
                          </Button>
                        </div>
                      )}
                    </div>
                    <List>
                      <ListItem>
                        {isEditing ? (
                          <TextField
                            fullWidth
                            label="Store Name"
                            value={editForm.name}
                            onChange={this.handleInputChange('name')}
                            variant="outlined"
                          />
                        ) : (
                          <Typography component="p" className={classes.textTitle}>
                            {name}
                          </Typography>
                        )}
                      </ListItem>
                      <ListItem>
                        <ListItemIcon>
                          <LocationOnIcon />
                        </ListItemIcon>
                        {isEditing ? (
                          <TextField
                            fullWidth
                            label="Location"
                            value={editForm.location}
                            onChange={this.handleInputChange('location')}
                            variant="outlined"
                          />
                        ) : (
                          <ListItemText
                            primary={
                              <Typography style={{ color: 'black' }}>
                                {location}
                              </Typography>
                            }
                          />
                        )}
                      </ListItem>
                      <ListItem alignItems="flex-start">
                        <ListItemIcon>
                          <ContactPhoneIcon />
                        </ListItemIcon>
                        {isEditing ? (
                          <TextField
                            fullWidth
                            label="Phone"
                            value={editForm.phone}
                            onChange={this.handleInputChange('phone')}
                            variant="outlined"
                          />
                        ) : (
                          <ListItemText
                            primary={
                              <Typography style={{ color: 'black' }}>
                                {phone}
                              </Typography>
                            }
                          />
                        )}
                      </ListItem>
                      <ListItem alignItems="flex-start">
                        <ListItemIcon>
                          <ContactMailIcon />
                        </ListItemIcon>
                        {isEditing ? (
                          <TextField
                            fullWidth
                            label="Email"
                            value={editForm.email}
                            onChange={this.handleInputChange('email')}
                            variant="outlined"
                          />
                        ) : (
                          <ListItemText
                            primary={
                              <Typography style={{ color: 'black' }}>
                                {email}
                              </Typography>
                            }
                          />
                        )}
                      </ListItem>
                      <ListItem alignItems="flex-start">
                        <ListItemIcon>
                          <AccessTimeIcon />
                        </ListItemIcon>
                        {isEditing ? (
                          <div style={{ display: 'flex', gap: '8px', width: '100%' }}>
                            <TextField
                              label="Hora de Apertura"
                              value={editForm.openHour}
                              onChange={this.handleInputChange('openHour')}
                              variant="outlined"
                              placeholder="9:00 AM"
                              helperText="Formato: 9:00 AM"
                            />
                            <TextField
                              label="Hora de Cierre"
                              value={editForm.closeHour}
                              onChange={this.handleInputChange('closeHour')}
                              variant="outlined"
                              placeholder="6:00 PM"
                              helperText="Formato: 6:00 PM"
                            />
                          </div>
                        ) : (
                          <ListItemText
                            primary={
                              <Typography style={{ color: 'black' }}>
                                {`${openHourDisplay} - ${closeHourDisplay}`}
                              </Typography>
                            }
                          />
                        )}
                      </ListItem>
                      <ListItem alignItems="flex-start">
                        <ListItemIcon>
                          <CategoryIcon />
                        </ListItemIcon>
                        <ListItemText
                          primary={this.renderCategories(categories)}
                        />
                      </ListItem>
                    </List>
                  </GridItem>
                </GridContainer>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </React.Fragment>
    );
  }
}

// Mark: default props
DetailStore.defaultProps = {
  classes: {},
  detailStore: {}
};

// Mark: PropsType
DetailStore.propTypes = {
  classes: PropTypes.object,
  detailStore: PropTypes.object,
  updateStoreByAdmin: PropTypes.func
};

const DetailStoreById = graphql(getStoreByAdmin, {
  props: ({ data }) => ({
    loading: data.loading,
    detailStore: data.getStoreByAdmin,
    data: data
  }),
  options: props => {
    return {
      variables: { id: Number(props.match.params.id) },
      fetchPolicy: 'cache-and-network'
    };
  }
});

const Update = graphql(updateStoreByAdmin, { name: 'updateStoreByAdmin' });

export default withStyles(styles)(
  compose(
    DetailStoreById,
    Update
  )(DetailStore)
);
